import Vue from 'vue';

const id = 'form-lung-cancer-eligibility-tool';

const LungCancerTool = {
	/* eslint-disable */
	Init() {
		if (document.getElementById(id)) {
			new Vue({
				el: `#${id}`,
				data: {
					questionsCount: $('.list--questions .list--item').length,
					currentQuestion: 1,
					yearsSmoked: null,
					cigsPerDay: null,
					packsPerDay: null,
					packYears: null
				},
				methods: {
					reset() {
						this.currentQuestion = 1;
						this.yearsSmoked = null,
						this.cigsPerDay = null,
						this.packsPerDay = null,
						this.packYears = null
					},
					next() {
						this.currentQuestion += 1;
					},
					calculate() {
						if (this.yearsSmoked != null && this.cigsPerDay != null) {
							this.currentQuestion = 0;
							this.packsPerDay = this.cigsPerDay / 20;
							this.packYears = this.yearsSmoked * this.packsPerDay;

							if (this.packYears >= 20) {
								GA.TrackPageView(`${document.location.href}#eligible`);
							} else {
								GA.TrackPageView(`${document.location.href}#not-eligible`);
							}
						}
					},
					end() {
						this.currentQuestion = 0;
					}
				}
			});
		}
		/* eslint-enable */
	}
};

export default LungCancerTool;
